/* eslint-disable jsx-a11y/control-has-associated-label */
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import LeadModalContext from '../../../../LeadModalContext';
import { ExtraGuestsContainer } from '../../LeadModalStayDetailsTab.styles';
import GovernmentFieldValue from '../fields/GovernmentFieldValue';

const ExtraGuests = () => {
  const { t } = useTranslation();
  const { lead } = useContext(LeadModalContext);

  if (!lead?.extraGuests) {
    return null;
  }

  return (
    <ExtraGuestsContainer>
      <h3>{t('componentLead.modal.stayDetailsTab.guestInfo.extraGuest')}</h3>

      {lead.extraGuests.map(
        ({
          firstName,
          lastName,
          email,
          age,
          phoneNumber,
          identificationDocumentUrl,
          passportCountry,
          passportID,
        }) => (
          <div
            key={encodeURI(email)}
            className="extra-guest"
            data-testid={`extra-guest-${encodeURI(email)}`}
          >
            {firstName || lastName ? (
              <p data-testid="extra-guest-name">
                <strong>{`${firstName || ''} ${lastName || ''}`}</strong>
              </p>
            ) : null}

            {email ? <p data-testid="extra-guest-email">{email}</p> : null}

            {phoneNumber ? (
              <p data-testid="extra-guest-phone-number">{phoneNumber}</p>
            ) : null}

            {age ? (
              <p data-testid="extra-guest-age">
                {t('componentLead.modal.stayDetailsTab.guestInfo.yearsOld', {
                  age,
                })}
              </p>
            ) : null}

            {passportCountry || passportID || identificationDocumentUrl ? (
              <p data-testid="extra-guest-identification-document-url">
                <GovernmentFieldValue
                  passportID={passportID}
                  passportCountryCode={passportCountry}
                  identificationDocumentUrl={identificationDocumentUrl}
                />
              </p>
            ) : null}
          </div>
        ),
      )}
    </ExtraGuestsContainer>
  );
};

export default ExtraGuests;
